import { Link } from "react-router-dom";
import { ArrowRight, FileCode2, Cpu, Coffee, CheckCircle2 } from "lucide-react";

const ICONS = { python: FileCode2, cpp: Cpu, java: Coffee };

const DIFFICULTY_LABEL = { easy: "Leicht", medium: "Mittel", hard: "Schwer" };
const DIFFICULTY_CLASS = { easy: "bg-success", medium: "bg-warning", hard: "bg-error text-white" };

export default function ChallengeCard({ challenge }) {
  const Icon = ICONS[challenge.language] || FileCode2;
  return (
    <Link
      to={`/challenges/${challenge.id}`}
      data-testid={`challenge-card-${challenge.id}`}
      className="nb-card nb-press p-5 flex flex-col gap-3 group"
    >
      <div className="flex items-start justify-between">
        <div className="h-11 w-11 rounded-xl border-2 border-black flex items-center justify-center bg-muted nb-shadow-sm">
          <Icon className="h-5 w-5" strokeWidth={2.5} />
        </div>
        {challenge.solved && (
          <CheckCircle2 className="h-6 w-6 text-success" strokeWidth={2.5} data-testid={`challenge-solved-${challenge.id}`} />
        )}
      </div>
      <h3 className="font-heading font-black text-lg tracking-tight">{challenge.title}</h3>
      <div className="flex items-center gap-2">
        <span className="text-[11px] font-bold uppercase tracking-wide border-2 border-black rounded-full px-2.5 py-0.5 bg-white">
          {challenge.language}
        </span>
        <span className={`text-[11px] font-bold uppercase tracking-wide border-2 border-black rounded-full px-2.5 py-0.5 ${DIFFICULTY_CLASS[challenge.difficulty]}`}>
          {DIFFICULTY_LABEL[challenge.difficulty] || challenge.difficulty}
        </span>
      </div>
      <div className="flex items-center gap-1 font-bold text-sm text-primary mt-auto">
        Lösen
        <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" strokeWidth={2.5} />
      </div>
    </Link>
  );
}
